<template  id="map-template">
  <div
    class="flexshu"
    style="height: 100%; padding-left: 15px; padding-right: 15px"
  >
    <div class="tab_box betw topOneBox">
      <div
        class="topOne"
        :class="[noHandlemsg ? 'bgtopOneActive' : 'bgtopOne']"
        @click="changenoHandlemsg()"
      >
        <div class="nohandletext">{{ noHandlemsgNum }}</div>
        未读消息
      </div>
      <div
        class="topOne"
        :class="[noHandletask ? 'bgtopOneActive' : 'bgtopOne']"
        @click="changenoHandleTask()"
      >
        <div class="nohandletext">{{ noHandleTaskNum }}</div>
        未处理任务
      </div>
    </div>
    <div class="tab_box fatherTab">
      <div
        :class="[activeTab == '0' ? 'belowTabActive' : 'belowTab']"
        @click="changeMsgTask(0)"
      >
        消息中心
      </div>
      <div
        :class="[activeTab == '1' ? 'belowTabActive' : 'belowTab']"
        style="margin-left: 24px"
        @click="changeMsgTask(1)"
      >
        任务中心
      </div>
    </div>
    <!-- style="height:0px;overflow:hidden;" -->
    <!-- <div class="btn-audio" v-show="false"> -->
    <audio
      :src="audiosrc"
      id="source"
      loop
      autoplay
      controls
      v-show="false"
    ></audio>
    <!-- </div> -->
    <!-- 消息中心 -->
    <div class="task_box flexshu" v-show="activeTab == '0'">
      <div class="task_tab tab_box">
        <div
          :class="[msgTabActiveind == ind ? 'task_tabActive' : 'task_tabOne']"
          style="margin-right: 10px"
          @click="changeMsgTab(ind)"
          v-for="(item, ind) in msgTab"
          :key="ind"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="table-chart" style="margin-top: 10px">
        <p v-if="tableData.length == 0" class="space">暂无该类型消息</p>
        <ul class="Info_box" v-if="tableData.length > 0">
          <li
            class="Info_one"
            style="list-style: none"
            v-for="(item, index) in tableData"
            @click="lookMsgDetail(item)"
            :key="index"
          >
            <div class="topInfo tab_box betw">
              <div class="tab_box">
                <div
                  :class="[
                    item.isRead == 0 || item.isRead == null
                      ? 'msgStatus'
                      : 'ml',
                  ]"
                ></div>
                <div class="leftname textOver">{{ item.messageTypeName }}</div>
                <div class="textOver timeText">{{ item.dataTime }}</div>
              </div>
              <!-- <div
                class="fontBlue fontStatus textOver"
                :class="{
                  fontWhite: item.status == '1',
                  fontRed: item.status == '0',
                }"
              >
                {{ formatStatus(item.status) }}
              </div> -->
            </div>
            <div class="contenttext ml" v-html="item.content"></div>
          </li>
        </ul>
        <div style="position: absolute; bottom: 6rem; width: 100%; left: 0px">
          <el-pagination
            style="margin: 0 auto; display: flex; justify-content: center"
            small
            layout="prev, pager, next"
            :page-size="PageSize"
            :current-page="msgcurrentPage"
            @prev-click="search"
            @next-click="search"
            @current-change="search"
            :total="msgTotalNum"
          >
          </el-pagination>
        </div>
      </div>
      <div class="addBtn" @click="addTask">+新增任务</div>
    </div>

    <!-- 任务的显示信息 -->
    <div class="task_box flexshu" v-show="activeTab == '1'">
      <div class="task_tab tab_box">
        <div
          :class="[taskTabIndex == '0' ? 'task_tabActive' : 'task_tabOne']"
          @click="changeTaskTab(0)"
        >
          全部
        </div>
        <div
          :class="[taskTabIndex == '1' ? 'task_tabActive' : 'task_tabOne']"
          style="margin-left: 24px"
          @click="changeTaskTab(1)"
        >
          进行中
        </div>
        <div
          :class="[taskTabIndex == '2' ? 'task_tabActive' : 'task_tabOne']"
          style="margin-left: 24px"
          @click="changeTaskTab(2)"
        >
          已完成
        </div>
      </div>
      <div class="table-chart2" style="margin-top: 10px">
        <ul class="Info_box">
          <li
            class="Info_one"
            v-for="(task, index) in taskTableData"
            @click="lookDetail(task)"
            :key="index"
          >
            <div class="topInfo tab_box betw">
              <div class="tab_box">
                <!-- <img style="width:38px;height:auto;" src="../../../theme-default/src/img/SOS.png" alt=""> -->
                <div
                  class="fontYellow"
                  :class="{
                    fontBlue: task.TaskStatus == '0',
                    fontGreen: task.TaskStatus == '2',
                    fontWhite: task.TaskStatus == '1',
                    fontRed: task.TaskStatus == '3',
                  }"
                >
                  {{ taskStatus(task.TaskStatus) }}
                </div>
                <div style="margin-left: 6px; color: #2ac1ff">
                  {{ formatDate(task.CreateTime) }}
                </div>
              </div>
            </div>
            <div
              class="textOver"
              style="color: #2ac1ff; font-size: 0.24rem; margin-top: 12px"
            >
              {{ task.TaskDesc }}
            </div>
          </li>
        </ul>
        <div>
          <div style="position: absolute; bottom: 6rem; width: 100%; left: 0px">
            <el-pagination
              style="margin: 0 auto; display: flex; justify-content: center"
              small
              layout="prev, pager, next"
              :current-page="taskcurrentPage"
              :page-size="PageSize"
              @prev-click="searchTaskPage"
              @current-change="searchTaskPage"
              @next-click="searchTaskPage"
              :total="taskTotalNum"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div class="addBtn" @click="addTask">+新增任务</div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MyApis from "../../../apis";
import {
  handleMsg,
  getMsgList,
  saveMsg,
} from "../../../../../../request/msgApi";
import { getZiDian, getChildGrop } from "../../../../../../request/api";
import websoket from "../../../../../../websoket/websoket";
import qAudio from "../../../../../../assets/qAudio.mp3";
import rAudio from "../../../../../../assets/rAudio.mp3";
export default {
  name: "HomeViewMessageCenter",
  componentName: "HomeViewMessageCenter",
  components: {},
  props: {},
  data() {
    return {
      audiosrc: "",
      autoplay: true,
      showAudio: false,
      noHandlemsg: true,
      noHandletask: true,
      ExecutId: "newtaskfortaskcenter",
      msgcurrentPage: 1,
      taskcurrentPage: 1,
      PageSize: 20,
      tableData: [],
      AlertType: null, //预警类型
      AlertTypeArr: [],
      AlerteLevel: null, //预警级别
      AlerteLevelArr: [],
      activeTab: 0,
      msgTabActiveind: 0,
      taskTabIndex: 0,
      taskTableData: [],
      isNewtaskVisiable: false,
      msgkey: {
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTasknewtaskfortaskcenter",
      },
      msgTotalNum: 0,
      taskTotalNum: 100,
      msgTab: [
        {
          name: "全部",
          params: {},
        },
        {
          name: "预警",
          params: {
            messageType: "early_warning",
          },
        },
        {
          name: "呼叫",
          params: {
            messageType: "call",
          },
        },
        {
          name: "SOS",
          params: {
            messageType: "sos",
          },
        },
        {
          name: "求助",
          params: {
            messageType: "help",
          },
        },
        // {
        //   name: "事件",
        //   params: {
        //     messageType: "event",
        //   },
        // },
      ],
      noHandlemsgNum: "",
      noHandleTaskNum: "",
      msgkey: {
        emergencyFinishTaskKey:
          "MessageKey_EmergencyFinishTasknewtaskfortaskcenter",
        startTaskMsgKey: "MessageKey_TaskCenterStartTask",
      },
      ws: "",
      lockReconnect: false, //是否真正建立连接
      timeout: 28 * 1000, //30秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
    };
  },

  created() {
    let index = this.msgTabActiveind;
    let param = this.msgTab[index].params;
    if (this.noHandlemsg) {
      param.isRead = 0;
      // param["isRead"] = 0;
    }
    this.getNewMsg(param);
    // 订阅已完成任务
    this.$notify.subscript(this.msgkey.emergencyFinishTaskKey, (x) =>
      this.onEmergencyFinishTaskKey(x)
    );
    // 订阅新增任务
    this.$notify.subscript(this.msgkey.startTaskMsgKey, (x) =>
      this.onEmergencyFinishTaskKey(x)
    );
    //  初始化websoket
    this.startWebsoket();
  },
  mounted: function () {
    // this.search();
    if (this.noHandletask) {
      this.searchTask({ TaskStatus: "1" });
    }
    this.$notify.subscript(
      "msgkey_business_alarm", //订阅消息的key
      (x) => this.onRecv(x)
    );
  },
  methods: {
    ...mapActions(["submittEarlyMsg"]),
    onRecv(x) {
      var content = x.firstBlock().text;

      // content = "f090afae-ae71-4ef4-9bdd-6af610aa5fb3";
      if (content) {
        let index = this.msgTabActiveind;
        let param = this.msgTab[index].params;
        if (this.noHandlemsg) {
          param.isRead = 0;
          // param["isRead"] = 0;
        }
        this.getNewMsg(param);
      }
    },
    playAudio() {
      let myAudio = document.getElementById("source");
      this.audiosrc = rAudio;
      //  myAudio.play();
    },
    closeAudio() {
      let myAudio = document.getElementById("source");
      this.audiosrc = "";
      //  myAudio.pause();
    },
    startWebsoket() {
      var ws = websoket.initWebsoket();
      this.ws = ws;
      ws.onopen = this.onopen;
      ws.onmessage = this.onMessage;
      ws.onclose = this.onclose;
      ws.onerror = this.onerror;
    },
    onMessage(event) {
      // console.log('event')
      // console.log(event)
      let _this = this;
      if (event.data) {
        var result = JSON.parse(event.data);
        // console.log('result')
        // console.log(result)
        if (result.type == "MESSAGE") {
          console.log("收到了消息");
          //  _this.earlyMsgData = result.data;
          _this.$store.dispatch("submittEarlyMsg", result.data);
          _this.$emit("showEarlymsg", result.data);
          _this.playAudio();
          setTimeout(function () {
            _this.closeAudio();
          }, 3000);
          if (_this.noHandlemsg) {
            let index = _this.msgTabActiveind;
            let param = _this.msgTab[index].params;
            param.status = "0";
            _this.getNewMsg(param);
          } else {
            let index = _this.msgTabActiveind;
            let param = _this.msgTab[index].params;
            param.status = "";
            _this.getNewMsg(param);
          }
          //  _this.getNewMsg({"status":"1"});
          //  _this.getNewMsg({"status":"2"});
        } else if (result.type == "PONG") {
          //  _this.start()
        }
        //收到服务器信息，心跳重置
        this.reset();
      }
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.startWebsoket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        // if (self.ws.readyState == 1) {//如果连接正常
        self.ws.send("ping");
        // }else{//否则重连
        //   self.reconnect();
        // }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.ws.close();
        }, self.timeout);
      }, self.timeout);
    },
    onopen() {
      //开启心跳
      this.start();
    },
    onclose(e) {
      console.log("关闭了");
      console.log(e);
      this.ws.close();
      //重连
      this.reconnect();
    },
    onerror(e) {
      console.log("出现错误");
      //重连
      this.reconnect();
    },
    onEmergencyFinishTaskKey() {
      if (this.noHandletask) {
        this.searchTask({ TaskStatus: "1" });
      } else {
        this.searchTask({ TaskStatus: "" });
      }
      this.searchTask({ TaskStatus: "1" });
      this.searchTask({ TaskStatus: "2" });
    },
    addTask() {
      this.$emit("addTask", true);
    },
    // 查看任务详情
    lookDetail(task) {
      // console.log('task.ExecutTaskId')
      // console.log(task.ExecutTaskId)
      this.$emit("lookDetail", task.ExecutTaskId);
    },
    // 查看消息详情
    lookMsgDetail(msg) {
      //修改消息为已读
      if (msg.isRead != 1) {
        msg.isRead = 1;
        this.updateMsgStatus(msg);
      }

      this.$emit("lookMsgDetail", String(msg.id), msg);
    },
    updateMsgStatus(msg) {
      const updateParam = {
        id: msg.id,
        isRead: 1,
      };
      saveMsg(updateParam).then((res) => {});
    },
    changenoHandlemsg() {
      if (this.activeTab == 1) {
        return;
      }
      this.noHandlemsg = !this.noHandlemsg;
      let index = this.msgTabActiveind;
      // let param = this.msgTab[index].params;
      let param = {};
      if (this.noHandlemsg) {
        param.isRead = 0;
        param.messageType = this.msgTab[index].params.messageType;
      } else {
        param = {};
        param.messageType = this.msgTab[index].params.messageType;
      }
      this.getNewMsg(param);
    },
    changenoHandleTask() {
      if (this.activeTab == 0) {
        return;
      }
      if (this.taskTabIndex == 1) {
        return;
      }
      if (this.taskTabIndex == 2) {
        return;
      }

      this.noHandletask = !this.noHandletask;
      let param = {
        TaskStatus: "1",
      };
      if (this.noHandletask) {
        param.TaskStatus = "1";
      } else {
        param.TaskStatus = "";
      }
      this.searchTask(param);
    },
    changeMsgTask(index) {
      this.activeTab = index;
    },
    changeMsgTab(index) {
      this.msgTabActiveind = index;
      let param = {};
      if (this.noHandlemsg) {
        param.isRead = 0;
        param.messageType = this.msgTab[index].params.messageType;
      } else {
        param = {};
        param.messageType = this.msgTab[index].params.messageType;
      }
      this.getNewMsg(param);
    },
    changeTaskTab(index) {
      this.taskTabIndex = index;
      //  let param=this.msgTab[index].params
      let params = {
        TaskStatus: "",
      };
      if (index == 0) {
        params.TaskStatus = "";
      } else if (index == 1) {
        params.TaskStatus = "1";
      } else if (index == 2) {
        params.TaskStatus = "2";
      }
      this.searchTask(params);
    },
    getNewMsg(paramOther) {
      let that = this;
      let params = {
        page: this.msgcurrentPage,
        size: this.PageSize,
        order: "id",
        sort: "desc",
      };
      Object.assign(params, paramOther);
      if (paramOther.isRead === 0) {
        Object.assign(params, paramOther);
      }

      getMsgList(params).then((res) => {
        if (res.code == 0) {
          that.tableData = res.data;
          that.msgTotalNum = res.count;
          if (params.isRead == 0) {
            that.noHandlemsgNum = res.count;
          } else {
            that.noHandlemsgNum = "";
          }
        }
      });
    },
    search(val) {
      // console.log(val)
      this.msgcurrentPage = val;
      let index = this.msgTabActiveind;
      let param = this.msgTab[index].params;
      this.getNewMsg(param);
    },
    searchTaskPage(val) {
      // console.log(val)
      this.taskcurrentPage = val;
      let index = this.taskTabIndex;
      let param = { TaskStatus: "" };
      if (index == 0) {
        if (this.noHandletask) {
          param.TaskStatus = "1";
        } else {
          param.TaskStatus = "";
        }
      } else {
        param.TaskStatus = index;
      }
      this.searchTask(param);
    },
    //日期列表展示格式
    formatDate(date) {
      // 获取单元格数据
      let data = date;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("MM/dd hh:mm");
    },
    formatStatus(data) {
      if (data == "0") return "待处理";
      else if (data == "1") return "已处理";
      else if (data == "10") return "未接通";
      else if (data == "20") return "已接通";
      return "";
    },
    taskStatus(status) {
      if (status == "0") return "未处理";
      else if (status == "1") return "进行中";
      else if (status == "2") return "已完成";
      else if (status == "3") return "异常";
      else if (status == "4") return "关闭";
      return "";
    },
    searchTask(param) {
      let searchInfo = {
        ExecutId: "newtaskfortaskcenter",
        Validity: 1,
        PageSize: this.PageSize,
        PageIndex: this.taskcurrentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      if (param) {
        Object.assign(searchInfo, param);
      }
      new MyApis.ExecutTaskApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.taskTableData = r.PageContents;
          this.taskTotalNum = r.BaseSearch.TotalCount;
          if (param.TaskStatus == "1") {
            this.noHandleTaskNum = r.BaseSearch.TotalCount;
          } else {
            this.noHandleTaskNum = "";
          }
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    getExecWayShow(row, column) {
      let data = row[column.property];
      if (data == "1") return "自动";
      else return "人工";
    }
  },
};
</script>
<style lang="scss" scoped>
.flexshu {
  display: flex;
  // align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}
.topOneBox {
  height: 6rem;
  width: 100%;
}
.fatherTab {
  height: 68px;
  justify-content: flex-start !important;
}
.task_box {
  flex: 1;
  overflow: auto;
  padding-bottom: 8.4rem;
  box-sizing: border-box;
}
.tab_box {
  display: flex;
  align-items: center;
}
.task_tab {
  height: 28px;
}
.betw {
  justify-content: space-between;
}
.topOne {
  width: 15.6rem;
  height: 6rem;
  line-height: 6rem;
  font-size: 0.2rem;
  text-align: right;
  padding-right: 2.6rem;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  font-size: 1.8rem;
}
.nohandletext {
  color: #2bc2ff;
  font-size: 1.6rem;
  position: absolute;
  bottom: 0rem;
  left: 0rem;
  width: 2.8rem;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: center;
  border-radius: 50%;
}
.bgtopOne {
  background: url("../../../theme-default/src/img/msg_bg.png") no-repeat;
  background-size: 100% 100%;
  color: #d6f0ff;
  opacity: 0.66;
}
.bgtopOneActive {
  background: url("../../../theme-default/src/img/msg_bg_active.png") no-repeat;
  background-size: 100% 100%;
  color: #fff;
}
.belowTab {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2.6rem;
  letter-spacing: 1px;
  color: #e4f7ff;
  opacity: 0.49;
  cursor: pointer;
  margin-top: 1.5rem;
}
.belowTabActive {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2.6rem;
  letter-spacing: 1px;
  color: #23c3ff;
  background-image: linear-gradient(
    0deg,
    rgba(11, 58, 119, 0.68) 0%,
    rgba(12, 55, 109, 0.34) 32%,
    #0c3364 64%,
    #0c2f59 100%
  );
  border-bottom: 2px solid #00c6ff;
  cursor: pointer;
}
.task_tabActive {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2.4rem;
  letter-spacing: 0px;
  color: #23c3ff;
  border-bottom: 2px solid #00c6ff;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  //  width:2.8rem;
  height: 2.4rem;
}
.task_tabOne {
  // width:2.8rem;
  height: 2.4rem;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 2.4rem;
  letter-spacing: 0px;
  color: #e4f7ff;
  opacity: 0.5;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Info_box {
  padding-left: 0px;
  .Info_one {
    list-style: none;
    margin-bottom: 10px;
    width: 100%;
    // height: 80px;
    padding: 15px 20px;
    box-sizing: border-box;
    background-image: linear-gradient(
      90deg,
      rgba(9, 36, 75, 0.4) 0%,
      rgba(17, 58, 116, 0.71) 26%,
      #174d9a 50%,
      rgba(24, 79, 157, 0.98) 52%,
      rgba(17, 58, 116, 0.69) 76%,
      rgba(9, 36, 75, 0.4) 100%
    );
    .topInfo {
      width: 100%;
      height: 23px;
      line-height: 23px;
    }
  }
}
.fontBlue {
  color: #3affff !important;
}
.fontGreen {
  color: green !important;
}
.fontWhite {
  color: #ffffff !important;
  opacity: 0.4;
}
.fontRed {
  color: #fe4e4e !important;
}
.fontYellow {
  color: #2bc2ff;
}
.addBtn {
  width: 80%;
  height: 35px;
  background: #002c55;
  border: 1px solid #2ac1ff;
  opacity: 0.66;
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  margin-left: -40%;
  text-align: center;
  line-height: 35px;
}
.table-chart {
  flex: 1;
  overflow: auto;
}
/*定义滚动条的整体样式使其变窄*/
// .table-chart::-webkit-scrollbar {
//   width: 0px;
//   height: 0px;
//   display: none;
// }
// .table-chart2::-webkit-scrollbar {
//   width: 0px;
//   height: 0px;
//   display: none;
// }
.table-chart2 {
  flex: 1;
  overflow: auto;
}
.textOver {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.marleft24 {
  margin-left: 2.4rem;
}
.leftname {
  width: 4.6rem;
  height: 2.4rem;
  border: solid 1px #2bc2ff;
  color: #2ac1ff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  line-height: 2.4rem;
}
.timeText {
  width: 16rem;
  margin-left: 6px;
  color: #2ac1ff;
}
.fontStatus {
  width: 4.8rem;
  font-size: 1.4rem;
}
.contenttext {
  color: #2ac1ff;
  font-size: 1.6rem;
  margin-top: 12px;
}
.marlefttop {
  margin-left: 1rem;
}
.space {
  text-align: center;
  font-size: 14px;
  margin-top: 20px;
}
.msgStatus {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  background-color: #fe4e4e;

  margin-right: 1rem;
}
.ml {
  margin-left: 2.2rem;
}
</style>